import AboutUs from "../../apis/main-about-us";

export default {
  ///////////////////////////////////////////////
  /////////////////BANNER/////////////////////
  /////////////////////////////////////////////

  add_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.add_banner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.getall_banner(payload);
        commit("GET_BANNER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.delete_banner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.update_banner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_banner_position({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.update_banner_position(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////
  /////////////////BANNER/////////////////////
  /////////////////////////////////////////////

  add_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.add_aboutUs(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.getall_aboutUs(payload);
        commit("GET_ABOUT_US", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.delete_aboutUs(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await AboutUs.update_aboutUs(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
